import produce from 'immer';
import {
  BASIC_MISSION_CREATE_REQUEST,
  BASIC_MISSION_INFO_ADD_BUDGET_REQUEST,
  BASIC_MISSION_INFO_DEPOSIT_REQUEST,
  BASIC_MISSION_INFO_DETAIL_REQUEST,
  BASIC_MISSION_INFO_REMOVE_REQUEST,
  BASIC_MISSION_LIST_REQUEST,
} from '../../constants/app/basicConstants';

const initialState = {

};

const basicReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case BASIC_MISSION_LIST_REQUEST:
        break;
      case BASIC_MISSION_CREATE_REQUEST:
        break;
      case BASIC_MISSION_INFO_DETAIL_REQUEST:
        break;
      case BASIC_MISSION_INFO_DEPOSIT_REQUEST:
        break;
      case BASIC_MISSION_INFO_ADD_BUDGET_REQUEST:
        break;
      case BASIC_MISSION_INFO_REMOVE_REQUEST:
        break;
      default:
        break;
    }
  });

export default basicReducer;
